export class RestorePasswordRequest {
    newPassword: string;
    restoreCode: string;

    constructor(password: string, code: string) {
        this.newPassword = password;
        this.restoreCode = code;
    }
}